import Check from '../Check';
import Report from '../Report';
import { MessageType } from '../Message';
import { Result } from '../Result';
import type { IMultiplePropagationConstraint } from '../../../stores/model/metamodel/multiple_propagation_constraint';

/**
 * Check if a multiple propagation constraint is consistent.
 *
 * Checks if:
 * - primary and secondary path are set
 */
class MPCConsistencyCheck extends Check<IMultiplePropagationConstraint> {
  static description = 'Check for multiple propagation constraint consistency';

  check(): Report {
    this.report = new Report();

    if (this.element.primaryPath == null) {
      this.report.addMessage(
        MessageType.ERROR,
        'Multiple propagation constraint has no primary path.',
        this,
        this.element
      );
    }
    if (this.element.secondaryPath == null) {
      this.report.addMessage(
        MessageType.ERROR,
        'Multiple propagation constraint has no secondary path.',
        this,
        this.element
      );
    }

    if (this.report.result === Result.NO_RESULT) {
      this.report.addMessage(
        MessageType.INFORMATION,
        'Multiple propagation constraint variables are set correctly.',
        this,
        this.element
      );
    }

    return this.report;
  }
}

export default MPCConsistencyCheck;
